/** G-152: Shopify's payment state, as a pill. */
const PAYMENT_STATES: Record<string, { label: string; className: string }> = {
  paid: { label: "Paid", className: "badge success" },
  pending: { label: "Payment pending", className: "badge warning" },
  authorized: { label: "Authorized, not captured", className: "badge warning" },
  partially_paid: { label: "Partially paid", className: "badge warning" },
  partially_refunded: { label: "Partially refunded", className: "badge danger" },
  refunded: { label: "Refunded", className: "badge danger" },
  voided: { label: "Voided", className: "badge danger" },
};

export function webPaymentState(status: string | null): {
  label: string;
  className: string;
} {
  if (status === null) return { label: "Payment state unknown", className: "badge muted" };
  return PAYMENT_STATES[status] ?? { label: status, className: "badge muted" };
}
